export default __webpack_public_path__ + "5b7caeef34a4a2be6860e378e30a722b.png";